<template functional>
	<button @click.prevent="'click' in listeners && listeners.click()" :class="`btn ${props.classes}`" v-if="props.kind === 'button'" :type="props.type">
		<slot/>
	</button>

	<a class="btn" v-else :href="props.href">
		<slot/>
	</a>
</template>

<script>
	import VueTypes from "vue-types"

	export default {
		props: {
			kind: VueTypes.oneOf(["button", "link"]).def("button"),
			classes: VueTypes.string.def(),

			/// BUTTON
			type: VueTypes.oneOf(["button", "submit", "cancel"]).def("submit"),

			/// LINK
			href: VueTypes.string.def(),
		}
	}
</script>

<style lang="scss" scoped>
	@use "~@scss/components/LmdtButton" as *;
</style>
